var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","fillRule":"evenodd","strokeWidth":"1"},React.createElement("g",{"id":"Button/Text/Green","transform":"translate(-233.000000, -18.000000)"},React.createElement("g",{"id":"Atom/Icon/Link/Arrow","transform":"translate(233.000000, 18.000000)"},[React.createElement("path",{"id":"Line","strokeLinejoin":"round","strokeWidth":"2","d":"M0,3.66796875 L9,3.66796875","className":"stroke-current","key":0}),React.createElement("polygon",{"id":"Triangle","fillRule":"evenodd","points":"10 0 14 8 6 8","className":"fill-current stroke-current","transform":"translate(10.000000, 4.000000) rotate(-270.000000) translate(-10.000000, -4.000000) ","key":1})]))));
}

Arrow.defaultProps = {"width":"14px","height":"8px","className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 14 8"};

module.exports = Arrow;

Arrow.default = Arrow;
